"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsId = void 0;
var PropsId;

(function (PropsId) {
  PropsId["properties"] = "properties";
  PropsId["config"] = "config";
  PropsId["labels"] = "labels";
  PropsId["annotations"] = "annotations";
  PropsId["sharedWith"] = "shared-with";
  PropsId["usedBy"] = "used-by";
  PropsId["targetLinks"] = "target-links";
  PropsId["sourceLinks"] = "source-links";
  PropsId["env"] = "env";
  PropsId["resources"] = "resources";
  PropsId["resourcesPerPod"] = "resources-per-pod";
  PropsId["nodeResources"] = "node-resources";
  PropsId["poolResources"] = "pool-resources";
  PropsId["clusterConsumption"] = "cluster-consumption";
  PropsId["clusterResources"] = "cluster-resources";
  PropsId["appConsumption"] = "app-consumption";
  PropsId["resourceRoleMatrix"] = "resource-role-matrix";
  PropsId["ingressApp"] = "ingress-app";
  PropsId["ingressCidr"] = "ingress-cidr";
  PropsId["egressApp"] = "egress-app";
  PropsId["egressCidr"] = "egress-cidr";
  PropsId["radioactive"] = "radioactive";
  PropsId["contents"] = "contents";
  PropsId["mount"] = "mount";
  PropsId["appCounters"] = "app-counters";
  PropsId["infraCounters"] = "infra-counters";
  PropsId["topIssueNamespaces"] = "top-issue-namespaces";
  PropsId["topIssues"] = "top-issues";
  PropsId["ruleConfig"] = "rule-config";
  PropsId["ruleItems"] = "rule-items";
  PropsId["ruleLogs"] = "rule-logs";
  PropsId["markerItems"] = "marker-items";
  PropsId["ruleAssistant"] = "rule-assistant";
  PropsId["health"] = "health";
  PropsId["podStages"] = "pod-stages";
})(PropsId = exports.PropsId || (exports.PropsId = {}));